import { QUERY_KEY } from 'constants/globalConstants'
import UserService from 'apiService/permissions'
import { useQuery } from 'react-query'

const useGetPermissionGroup = (pageSize, currentPage) => {
    return useQuery(QUERY_KEY.GET_PERMISSION_GROUP, () => UserService.getGroupPermission(pageSize, currentPage), {retry: false})
}

export default useGetPermissionGroup